(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-hotspot"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll(".hotspot-trigger").forEach(btn => {
    btn.addEventListener("click", async (e) => {
      e.stopPropagation();

      const hotspot = btn.closest(".hotspot");
      const popover = hotspot.querySelector(".hotspot-popover");
      const handle = btn.dataset.productHandle;

      document.querySelectorAll(".hotspot")
        .forEach(h => h.classList.remove("active"));

      hotspot.classList.add("active");

      if (!handle) return;

      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();

      popover.querySelector(".popover-title").innerText = product.title;
      popover.querySelector(".popover-price").innerText =
        Shopify.formatMoney(product.price);

      popover.querySelector(".popover-image").innerHTML =
        `<img src="${product.images[0]}" alt="${product.title}">`;

      popover.querySelector(".popover-link").href =
        `/products/${product.handle}`;
    });
  });

  document.addEventListener("click", () => {
    document.querySelectorAll(".hotspot")
      .forEach(h => h.classList.remove("active"));
  });

  document.addEventListener("DOMContentLoaded", () => {
    const isDesktop = window.matchMedia("(min-width: 720px)").matches;

    if (!isDesktop) return;

    const firstHotspot = document.querySelector(".hotspot-trigger");
    if (firstHotspot) {
      firstHotspot.click();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
